import React, { memo } from "react"
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  listItemIconClasses
} from "@mui/material"
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined"

export const ActionsCell = memo(
  /**
   * @param {{id?: string; buttonSize?: import("@mui/material").IconButtonProps['size']; onPreload?: () => void; actions: {label: React.ReactNode, divider?: boolean, icon?: React.ReactNode; onClick: Function}[]}} props
   */
  ({ id, buttonSize = "small", onPreload, actions }) => {
    const buttonRef = React.useRef(null)
    const [open, setOpen] = React.useState(false)

    const handleMenuClick = () => {
      if (onPreload) {
        onPreload()
      }
      setOpen(true)
    }

    const handleClose = () => {
      setOpen(false)
    }

    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <IconButton
          ref={buttonRef}
          onClick={handleMenuClick}
          onMouseOver={onPreload}
          size={buttonSize}
          data-testid={`${id}_button`}
          title="Show options"
          sx={{ visibility: actions.length ? "auto" : "hidden" }}
        >
          <MoreHorizOutlinedIcon
            fontSize="small"
            aria-controls={id}
            aria-haspopup="true"
            sx={{ color: "grey.500" }}
          />
        </IconButton>
        {open && (
          <Menu
            id={id}
            anchorEl={buttonRef.current}
            keepMounted
            open={open}
            onClose={handleClose}
            variant="selectedMenu"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
          >
            {actions.map((action, i) => {
              return (
                <MenuItem
                  sx={{
                    [`& .${listItemIconClasses.root}`]: { minWidth: 24 },
                    ["& svg"]: { fontSize: 18 }
                  }}
                  key={i}
                  data-joyride={action.dataJoyride}
                  divider={action.divider}
                  onClick={() => {
                    action.onClick()
                    handleClose()
                  }}
                >
                  {action.icon && <ListItemIcon>{action.icon}</ListItemIcon>}
                  <ListItemText>{action.label}</ListItemText>
                </MenuItem>
              )
            })}
          </Menu>
        )}
      </Box>
    )
  }
)
